/* eslint-env browser, jquery */
import 'bootstrap';
import domify from 'domify';
import page from 'modules/ab-page-js';
import $ from 'jquery';
import ContactForm from 'auth0-contact-form';
import { ContactUsForm } from 'components';
import { render as clientRender, unmountComponentAtNode } from 'react-dom';
import React from 'react';
import lottie from 'lottie-web';
import container from 'modules/section-content';
import './plugins/stalkerMenu';
import splash from './view/main.pug';
import metadata from './metadata.json';
import animationHero from './animations/hero/data.json';
import animationCustomerExperience from './animations/customer-experience/data.json';
import animationTelematics from './animations/telematics/data.json';
import animationCompliance from './animations/compliance/data.json';
import animationCollaboration from './animations/collaboration/data.json';

const metricsLib = window.metricsLib;
let onScrollAnimation = null;

export default function register() {
  page('/financial-services', render, snippets);
  page.exit('/financial-services', unmountContactForm);
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    ...(ctx.init ? {} : { view: domify(splash()) })
  };

  container.render(renderOptions);
  /* eslint-env browser */
  clientRender(
    <ContactUsForm
      source="financial"
      subject="New lead from Financial landing page"
      formId="financial-contact-form"
    />,
    document.querySelector('.contact-us-app')
  );
  return next();
}

function snippets(ctx, next) {
  setupContactForm();
  $('.container-menu').stalkerMenu();
  setupAnimations();
  next();
}

function setupAnimations() {
  const containerHero = document.getElementById('animation-hero');
  const containerCustomerExperience = document.getElementById('animation-customer-experience');
  const containerTelematics = document.getElementById('animation-telematics');
  const containerCollaboration = document.getElementById('animation-collaboration');
  const containerCompliance = document.getElementById('animation-compliance');

  const heroLottie = {
    container: containerHero,
    renderer: 'svg',
    loop: false,
    autoplay: false,
    animationData: animationHero
  };

  const customerExperienceLottie = {
    container: containerCustomerExperience,
    renderer: 'svg',
    loop: false,
    autoplay: false,
    animationData: animationCustomerExperience
  };

  const telematicsLottie = {
    container: containerTelematics,
    renderer: 'svg',
    loop: false,
    autoplay: false,
    animationData: animationTelematics
  };

  const collaborationLottie = {
    container: containerCollaboration,
    renderer: 'svg',
    loop: false,
    autoplay: false,
    animationData: animationCollaboration
  };

  const complianceLottie = {
    container: containerCompliance,
    renderer: 'svg',
    loop: false,
    autoplay: false,
    animationData: animationCompliance
  };

  playAnimations(
    heroLottie,
    customerExperienceLottie,
    telematicsLottie,
    collaborationLottie,
    complianceLottie
  );
}

function playAnimations(
  heroLottie,
  customerExperienceLottie,
  telematicsLottie,
  collaborationLottie,
  complianceLottie
) {
  const animation0 = lottie.loadAnimation(heroLottie);
  const animation1 = lottie.loadAnimation(customerExperienceLottie);
  const animation2 = lottie.loadAnimation(telematicsLottie);
  const animation3 = lottie.loadAnimation(collaborationLottie);
  const animation4 = lottie.loadAnimation(complianceLottie);

  animation0.play();
  onScrollAnimation = onScrollAnimationFactory(animation1, animation2, animation3, animation4);

  window.addEventListener('scroll', onScrollAnimation);
}

function onScrollAnimationFactory(animation1, animation2, animation3, animation4) {
  return () => {
    if ($('.section-0').hasClass('initialized')) {
      animation1.play();
    }
    if ($('.section-1').hasClass('initialized')) {
      animation2.play();
    }
    if ($('.section-2').hasClass('initialized')) {
      animation3.play();
    }
    if ($('.section-3').hasClass('initialized')) {
      animation4.play();
    }
  };
}

function setupContactForm() {
  const salesContactFormOptions = {
    onModalOpen() {
      metricsLib.track('click:contact-sales');
    },
    onFormSuccess(metricsData) {
      metricsLib.track('register:lead:b2b-contact-form', metricsData);
    },
    onFormFail(metricsData) {
      metricsLib.track('fail:register:lead:b2b-contact-form', metricsData);
    },
    source: 'financial-page'
  };
  const salesContactForm = new ContactForm(salesContactFormOptions);

  const salesFormButton = document.querySelector('.open-contact-form-modal');
  salesFormButton.addEventListener('click', () =>
    salesContactForm.show({ includePhoneField: true })
  );
}

function unmountContactForm(ctx, next) {
  unmountComponentAtNode(document.querySelector('.contact-us-app'));
  if (onScrollAnimation) {
    window.removeEventListener('scroll', onScrollAnimation);
  }
  next();
}



// WEBPACK FOOTER //
// ./src/pages/financial-services/client.js